import { Card, CardContent, Grid, Typography } from '@mui/material'
import { Title } from 'components'
import { useLayout } from 'context'
import { getOhioTitles, getSelectedVehicleForm } from 'controllers/ohioTitles/index'
import { OhioTitleDto, OhioTitleSelectedVehicleFormDto, OhioTitleVehicleDetailDto, OhioTitleVehicleDto } from 'dtos/ohioTitles'
import { Formik } from 'formik'
import { useEffect, useState } from 'react'
import OhioTitlesCard from './OhioTitlesCard'
import SelectedVehicleCard from './SelectedVehicleCard'
import SelectedVehicleOhioTitleApplicationPacket from './SelectedVehicleOhioTitleApplicationPacketCard'
import ApplicationPacketReadyToPrintCard from './ApplicationPacketReadyToPrintCard'
import { OhioTitleVehicleDtoValidator } from 'validators/ohioTitles'

export default function OhioTitles() {
  const { setIsLayoutLoading } = useLayout()

  const [state, setState] = useState<OhioTitleDto | undefined>(undefined)
  const [selected, setSelected] = useState<OhioTitleVehicleDto | undefined>(undefined)
  const [form, setForm] = useState<OhioTitleSelectedVehicleFormDto | undefined>(undefined)

  useEffect(() => {
    setIsLayoutLoading(true)
    getOhioTitles()
      .then(res => setState(res.value))
      .finally(() => setIsLayoutLoading(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (selected) {
      setIsLayoutLoading(true)
      getSelectedVehicleForm(selected.vehicleGuid)
        .then(res => setForm(res.value))
        .finally(() => setIsLayoutLoading(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])

  return (
    <>
      <Title>Ohio Titles</Title>

      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography fontWeight='bold' variant='h5'>
                Ohio Titles
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <OhioTitlesCard selected={selected} setSelected={setSelected} vehicles={state?.vehicles ?? []} />
        </Grid>

        {selected && (
          <Formik
            enableReinitialize
            initialValues={form?.data ?? ({} as OhioTitleVehicleDetailDto)}
            onSubmit={values => {
              /* Do nothing */
            }}
            validateOnBlur
            validateOnChange
            validationSchema={OhioTitleVehicleDtoValidator}
          >
            {() => (
              <>
                <Grid item xs={12}>
                  <SelectedVehicleCard selected={selected} form={form} />
                </Grid>

                <Grid item xs={12}>
                  <SelectedVehicleOhioTitleApplicationPacket
                    inspectionCompanies={form?.inspectionCompanies ?? []}
                    lienHolderCompanies={form?.lienHolderCompanies ?? []}
                    documentSignerPeople={form?.documentSignerPeople ?? []}
                    titleClerkPeople={form?.titleClerkPeople ?? []}
                    vehicleGuid={selected.vehicleGuid}
                    setSelected={setSelected}
                    setState={setState}
                  />
                </Grid>
              </>
            )}
          </Formik>
        )}

        <Grid item xs={12}>
          <ApplicationPacketReadyToPrintCard vehicles={state?.applicationPacketReadyToPrintVehicles ?? []} setState={setState} />
        </Grid>
      </Grid>
    </>
  )
}
